import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";
import Unauthorized from "../general/Unauthorized";
import Swal from "sweetalert2";

function Proveedores() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');
    let userdata = [];
    let clientData = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [toastMsg, setToastMsg] = useState('');

    const cols = [
        { name:'Nombre', selector:row => row.nombre_proveedor, sortable:true, width:'21%' },
        { name:'Documento', selector:row => row.numero_documento, sortable:true, width:'15%' },
        { name:'Tipo', selector:row => row.tipo_documento, sortable:false, width:'10%' },
        //{ name:'Contacto', selector:row => row.contacto, sortable:true, width:'12%' },
        { name:'Celular', selector:row => row.celular, sortable:false, width:'12%' },
        { name:'Email', selector:row => row.email, sortable:false, width: '24%' },
        { name:'Acción', cell:row => getBotones(row), width: '18%' }
    ];

    const getBotones = (item) => (
        <div className="d-flex flex-nowrap" style={{ gap: '6px' }}>
            <Link
                to={'/proveedor?id=' + item.id}
                className="btn btn-primary btn-sm"
                title="Editar"
                aria-label="Editar proveedor"
            >
                <i className="far fa-edit"></i>
            </Link>
            <Link
                to="#"
                onClick={(e) => { e.preventDefault(); showModal(item.id); }}
                className="btn btn-outline-danger btn-sm"
                title="Eliminar"
                aria-label="Eliminar proveedor"
            >
                <i className="fas fa-trash-alt"></i>
            </Link>
        </div>
    );


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a administrar personal y proveedores
        const tienePermiso = userdata.up && userdata.up.includes('administrarPersonalProveedores');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });

        axios.get('/proveedores?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    
                    setItems(response.data);
                    console.log(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });
    },[]);


    const eliminar = (e) => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            params: {
                id: e,
                uid: userdata.user_id
            }
        };
        
        axios.delete('/proveedor', config)
            .then(response => {
                if (response.status === 200) {
                    let nombreItem = "";
                    const nuevoItems = items.filter((item) => {
                        if (String(item.id) === String(e)) {
                            nombreItem = item.nombre_proveedor;
                            return false;
                        }
                        return true;
                    });

                    setItems(nuevoItems);
                    cerrar();
                    setToastMsg('El proveedor ' + nombreItem + ' ha sido eliminado');
                }
            })
            .catch(error => {
                cerrar();
                const data = error.response?.data || {};
                const docs = parseInt(data.documentos_soporte, 10);
                const egr = parseInt(data.egresos, 10);
                const tieneConteo = !Number.isNaN(docs) || !Number.isNaN(egr);

                let texto = data.message || 'No se pudo eliminar el proveedor.';
                if (tieneConteo && ((docs > 0) || (egr > 0))) {
                    const nDocs = Number.isNaN(docs) ? 0 : docs;
                    const nEgr = Number.isNaN(egr) ? 0 : egr;
                    texto = `Este proveedor tiene asociados ${nDocs} documento${nDocs === 1 ? '' : 's'} soporte y ${nEgr} egreso${nEgr === 1 ? '' : 's'}. Para eliminarlo, primero debes revisar estos registros asociados.`;
                }

                Swal.fire({
                    icon: 'warning',
                    title: 'No es posible eliminar el proveedor',
                    text: texto,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#3085d6'
                });
            });
    }

    const showModal = (e) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(e);
    }

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
    }

    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda
            }
        }

        axios.get('/proveedores',config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    },[terminoBusqueda]);


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link> </li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link> </li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link> </li>
                                        <li className="breadcrumb-item" key="bc4">Proveedores</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Proveedores</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                        <div className="row">
                            <div className="col-md-9">
                                <Link to="/nuevo-proveedor" className="btn btn-primary">Crear Nuevo</Link> 
                            </div>   
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Buscar</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                
                                <DataTable
                                columns={cols}
                                data={items}
                                pagination
                                paginationComponentOptions={{
                                    rowsPerPageText: 'Filas por página:',
                                    rangeSeparatorText: 'de',
                                    noRowsPerPage: false,
                                    selectAllRowsItem: true,
                                    selectAllRowsItemText: 'Todos'
                                }}
                                noDataComponent="No hay registros para mostrar"
                                id={'proveedores'}
                                />

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>

                <div className={'modal-container modal fade in '+modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">Eliminar Proveedor</h4>
                                <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                            </div>

                            <div className="modal-body">
                                ¿Esta Seguro Que Desea Eliminar La Opcion Seleccionada?
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => cerrar()}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => eliminar(idItemEliminar)}>Eliminar</button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade '+modalBackdropStatus}></div>

                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default Proveedores;